const PATH_ENV = process.env.NODE_ENV;
let SET_CONFIG = {};
if (PATH_ENV === 'development') {
  SET_CONFIG.baseURL = 'https://www.encmobile.com/gateway/pcapp/';
} else if (PATH_ENV === 'production') {
  SET_CONFIG.baseURL = 'https://www.encmobile.com/gateway/pcapp/';
} else {
  SET_CONFIG.baseURL = 'https://www.encmobile.com/gateway/pcapp/';
}

export default SET_CONFIG;
